import { FormControl, FormGroup } from '@angular/forms';
import { PolygonElement } from '../polygon-element';
import { PropertyMetadata } from '../../properties/property-types';

export abstract class PolygonMapItem extends PolygonElement {
    // Common properties for all map items
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";
    public override layerIndex: number = 5;
    
    constructor(formGroup: FormGroup, type: string) {
        super(formGroup);
        
        // Ensure Type is set in the form
        if (!formGroup.contains('Type')) {
            formGroup.addControl('Type', new FormControl(type));
        } else {
            formGroup.get('Type')?.setValue(type);
        }

        // Ensure color controls exist with defaults
        if (!formGroup.contains('OutlineColor')) {
            formGroup.addControl('OutlineColor', new FormControl('555555'));
        }
        if (!formGroup.contains('FillColor')) {
            formGroup.addControl('FillColor', new FormControl('e8e8e8'));
        }

        // Set colors from form values
    }
    public override draw(ctx: CanvasRenderingContext2D, offsetX?: number, offsetY?: number): void {
        if (!this.points || this.points.length < 3) return;

        ctx.beginPath();
        ctx.moveTo(this.points[0].x, this.points[0].y);
        
        for (let i = 1; i < this.points.length; i++) {
            ctx.lineTo(this.points[i].x, this.points[i].y);
        }
        
        ctx.closePath();

        ctx.fillStyle = '#' + this.formGroup.get('FillColor')?.value;
        ctx.fill();

        ctx.strokeStyle = '#' + this.formGroup.get('OutlineColor')?.value;
        ctx.stroke();
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        const baseMetadata = super.getPropertyMetadata();
        return [
            ...baseMetadata,
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                displayName: 'Width',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 2,
                category: 'Dimensions',
                getValue: (element) => element.getWidth(),
                setValue: (element, value) => element.setWidth(value)
            },
            {
                displayName: 'Length',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 3,
                category: 'Dimensions',
                getValue: (element) => element.getHeight(),
                setValue: (element, value) => element.setHeight(value)
            },
            {
                formControlName: 'OutlineColor',
                displayName: 'Border Color',
                inputType: { type: 'color' },
                order: 98,
                category: 'Appearance'
            },
            {
                formControlName: 'FillColor',
                displayName: 'Fill Color',
                inputType: { type: 'color' },
                order: 99,
                category: 'Appearance'
            }
        ];
    }

    public override updateForm(): void {
        super.updateForm();
    }
} 
